import React from 'react';
import { TableCell, TableRow } from '@mui/material';
import CustomRowTable from 'src/components/ui/table/custom-row-table';
import HeaderTableCell from 'src/components/ui/table/header-table-cell';

const ListTable = ({ items, selected = [] }) => {
  return (
    <CustomRowTable
      items={items}
      renderItem={(item, rowstyle, idx) => (
        <TableRow hover selected={selected.includes(idx)} sx={rowstyle}>
          <TableCell>{item.step}</TableCell>
          <TableCell>{item.name}</TableCell>
          <TableCell sx={{ textAlign: 'right', whiteSpace: 'normal' }}>
            {Array.isArray(item.status)
              ? item.status
                  .map(s => s.name)
                  .reduce((acc, name, idx) => {
                    const lineIdx = Math.floor(idx / 3);
                    if (!acc[lineIdx]) acc[lineIdx] = [];
                    acc[lineIdx].push(name);
                    return acc;
                  }, [])
                  .map((group, i) => <div key={i}>{group.join(', ')}</div>)
              : ''}
          </TableCell>
        </TableRow>
      )}>
        <TableRow>
          <HeaderTableCell sx={{ width: '5%' }}>Stt</HeaderTableCell>
          <HeaderTableCell sx={{ width: '30%' }}>Tiến độ</HeaderTableCell>
          <HeaderTableCell sx={{ width: '65%', textAlign: 'right', whiteSpace: 'nowrap' }}>Các trạng thái</HeaderTableCell>
        </TableRow>
    </CustomRowTable>
  );
};

export default ListTable;
